import { Money } from "@/components/Money";
import { ReportCard } from "@/components/reports/ReportCard";
import { periodLabel } from "@/components/reports/RevenueVsCost";

const COLS = [
  ["revenue", "Revenue"], ["gross_profit", "Gross Profit", true], ["cogs", "Cost of goods sold"], ["opex", "Operating Expenses"],
  ["operating_profit", "Operating Profit", true], ["other_charges", "Depreciation & finance"], ["total_expenses", "Total Expenses"], ["net_profit", "Net Profit", true],
];

export const PnlSummaryTable = ({ data, params, disabled }) => {
  const g = data.granularity;
  return (
    <ReportCard id="pnl_summary" title="P&L Summary" description={`One row per ${g === "monthly" ? "month" : "day"} · ${data.periods.length} rows`} params={params} disabled={disabled}>
      <div className="max-h-[560px] overflow-auto rounded-md border border-slate-200">
        <table className="w-full text-sm" data-testid="pnl-summary-table">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500">
            <tr>
              <th className="whitespace-nowrap px-4 py-2.5 text-left">Period</th>
              {COLS.map(([k, l]) => <th key={k} className="whitespace-nowrap px-4 py-2.5 text-right">{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.periods.map((p) => (
              <tr key={p.period} className="row-hover border-t border-slate-100" data-testid={`pnl-row-${p.period}`}>
                <td className="whitespace-nowrap px-4 py-2 text-slate-700">{periodLabel(p.period, g)}</td>
                {COLS.map(([k, , profit]) => <td key={k} className="px-4 py-2 text-right"><Money value={p[k]} profit={profit} /></td>)}
              </tr>
            ))}
          </tbody>
          <tfoot className="sticky bottom-0">
            <tr className="border-t-2 border-slate-900 bg-slate-50 font-semibold text-slate-900" data-testid="pnl-total-row">
              <td className="px-4 py-2.5">Total</td>
              {COLS.map(([k, , profit]) => <td key={k} className="px-4 py-2.5 text-right" data-testid={`pnl-total-${k}`}><Money value={data.totals[k]} profit={profit} /></td>)}
            </tr>
          </tfoot>
        </table>
      </div>
    </ReportCard>
  );
};
